export default {
    Title: 'Tham số báo cáo',
    ViewReport: 'Xem báo cáo',
    All: 'Tất cả',
    Option: 'Tùy chọn',
    TemplateReport: 'Mẫu báo cáo',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    SelectAll: '<<Tất cả>>',
    IsShowBankAccountAsAccountNumber: 'Hiển thị số liệu tại KB = Số liệu tại đơn vị',
    BankTreasury: "Tài khoản Ngân hàng, Kho bạc",
    BeginPeriodAmount: 'Số dư đầu kỳ',
    IncreasePeriodAmount: 'Phát sinh tăng trong kỳ',
    DecreasePeriodAmount: 'Phát sinh giảm trong kỳ',
    LastPeriodAmount: 'Số dư cuối kỳ',
};
